import React from "react";
import Pagination from "../components/common/pagination";
import ArticleListItem from "../components/article-list-item";
import Layout from "../components/layout";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
import SEO from "../components/seo";
var AllSpotlightsList = function AllSpotlightsList(_ref) {
    var data = _ref.data, pageContext = _ref.pageContext;
    var pageNumber = pageContext.pageNumber, pageCount = pageContext.pageCount;
    var pageTitle = "Alle Spotlights";
    return /*#__PURE__*/ React.createElement(Layout, {
        className: "is-spotlight"
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: pageTitle
    }), /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: pageTitle
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, data.allDatoCmsSpotlight.nodes.map(function (spotlight, index) {
        var _spotlight$briefing$i;
        return /*#__PURE__*/ React.createElement(ArticleListItem, {
            key: spotlight.id,
            authors: spotlight.briefing.authors,
            excerpt: spotlight.briefing.excerpt,
            to: "/spotlight/" + spotlight.slug + "/" + spotlight.briefing.slug + "/",
            title: spotlight.topic,
            image: (_spotlight$briefing$i = spotlight.briefing.image) === null || _spotlight$briefing$i === void 0 ? void 0 : _spotlight$briefing$i.fluid,
            smallTitle: spotlight.label,
            index: index,
            authorLinks: false,
            smallTitleClassName: "text-white-important",
            containerStyle: "text-white bg-makroGreen"
        });
    }))), /*#__PURE__*/ React.createElement(Pagination, {
        currentPage: pageNumber,
        pageCount: pageCount,
        basePath: "alle-spotlights"
    }));
};
var query = "1178835952";
export default AllSpotlightsList;
